export default __webpack_public_path__ + "static/media/cp_geo_by.3a1ae218.svg";